import React from "react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import { GeneralPublicRoutes } from "./generalPublicRoutes";

export const PublicPageRoutes: RouteObject[] = [...GeneralPublicRoutes];

const routes: RouteObject[] = [...PublicPageRoutes];

const router = createBrowserRouter(routes);

export const PublicRoutes = () => {
  return <RouterProvider router={router} />;
};
